import { useEffect } from "react";
import get from "lodash/get";
import {
  useAppContactlessConfigs,
  useCtxReferences,
  useIsAuthed,
  useSeparatedAppManifests,
  useShortLinks
} from "utils/selectors";
import { getContactlessConfigInitialValues } from "utils/contactless";
import { getDashboardInitialValues } from "utils/computation";
import { getAppUrlVariations } from "./application";
import { ORGANIZATION } from "utils/constants/models";
import { CONTACTLESS_PREVIEW_MODE } from "constants/contactless";
import { useFormikContext } from "formik";
import { FORM_KEY } from "utils/constants/form";
import PATHS from "utils/paths";

export const useContactlessConfigInitialValues = () => {
  const { merchantAccount, application, resource } = useCtxReferences();
  const contactlessConfigs = useAppContactlessConfigs();
  const { live: liveManifests } = useSeparatedAppManifests();

  let subdomain;
  let alias;
  if (application) {
    subdomain = application.subdomain;
    alias = application.alias;
  }
  const { shortLinks } = useShortLinks();
  const isAuthed = useIsAuthed();

  const formValues = getDashboardInitialValues({
    subdomain,
    alias,
    shortLinks,
    liveManifests
  });

  const variations = getAppUrlVariations({ application });
  formValues.resource = resource;
  formValues.previewMode = CONTACTLESS_PREVIEW_MODE.CODE;
  formValues.rootUrl = isAuthed
    ? resource === ORGANIZATION
      ? variations.subdomain
      : variations.alias
    : variations.standard;

  return getContactlessConfigInitialValues({
    formValues,
    merchantAccount,
    contactlessConfigData: get(contactlessConfigs, "[0].data")
  });
};

export const useContactlessRefreshUrl = () => {
  const {
    values: {
      [FORM_KEY]: { shortId, route, rootUrl, testMode }
    },
    setFieldValue
  } = useFormikContext();

  useEffect(() => {
    let updatedUrl;
    if (shortId || route) {
      if (shortId) {
        updatedUrl = testMode
          ? `${rootUrl}${PATHS.TEST_LINKS}/${shortId}`
          : `${rootUrl}${PATHS.LINKS}/${shortId}`;
      } else if (route) {
        updatedUrl = `${rootUrl}${route}`;
      }

      updatedUrl && setFieldValue("url", updatedUrl);
    }
  }, [shortId, route, testMode]);
};
